import { render, staticRenderFns } from "./EventEmptyLink.vue?vue&type=template&id=4829b792&scoped=true"
import script from "./EventEmptyLink.vue?vue&type=script&lang=js"
export * from "./EventEmptyLink.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4829b792",
  null
  
)

export default component.exports